import api from '@/apis/integration/integrationMeInvoiceApi.js';
import {usefilterActionCombo} from './filterActionCombo.js';
import {getCurrentInstance} from 'vue';

// Combo grid mẫu số hóa đơn
export const useInvoiceFormMEInvoiceComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const {proxy} = getCurrentInstance();
  const {extendFilter} = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onInvoiceFormMEInvoiceComboboxLoadData = (payload, row, column) => {
    payload.filter = extendFilter(payload.filter);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const invoiceFormMEInvoiceComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: '',
        dataField: 'InvSeries',
        width: 140,
      },
    ],
    displayField: 'inv_template_text',
    valueField: 'inv_template_id',
    queryMode: 'remote',
    dropdownWidth: 500,
    comboboxLoadData: onInvoiceFormMEInvoiceComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    invoiceFormMEInvoiceComboConfig,
    onInvoiceFormMEInvoiceComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
